import type { WorkspaceTab } from "./use-workspace-search-params";
import { WorkspaceSidebarOverview } from "./workspace-sidebar-overview";
import { WorkspaceSidebarSituation } from "./workspace-sidebar-situation";
import { WorkspaceSidebarHighlights } from "./workspace-sidebar-highlights";

export interface WorkspaceSidebarProps {
  walkthrough: any;
  scenarioRuns: any[] | undefined;
  runsChronological: any[];
  runNumber: number | undefined;
  walkthroughStepsCount: number;
  problemsCount: number;
  defaultBaseRunId: string | null;
  activeTab: WorkspaceTab;
  onSelectTab: (tab: WorkspaceTab) => void;
  projectId: string;
  guidanceRules: any[];
  onOpenReport?: () => void;
}

export function WorkspaceSidebar({
  walkthrough,
  scenarioRuns,
  runsChronological,
  walkthroughStepsCount,
  problemsCount,
  activeTab,
  onSelectTab,
  projectId,
  guidanceRules,
  onOpenReport,
}: WorkspaceSidebarProps) {
  const scenario = walkthrough.scenario;
  const persona = walkthrough.persona;
  const personaBrief = scenario?.brief || walkthrough.promptText;

  const whatWorked = Array.isArray(walkthrough.whatWorked)
    ? (walkthrough.whatWorked as string[])
    : [];
  const openQuestions = Array.isArray(walkthrough.openQuestions)
    ? (walkthrough.openQuestions as string[])
    : [];

  return (
    <aside className="space-y-6 w-full lg:w-88 shrink-0">
      <WorkspaceSidebarOverview
        walkthrough={walkthrough}
        scenarioRuns={scenarioRuns}
        runsChronological={runsChronological}
        walkthroughStepsCount={walkthroughStepsCount}
        problemsCount={problemsCount}
        activeTab={activeTab}
        onSelectTab={onSelectTab}
        projectId={projectId}
        onOpenReport={onOpenReport}
      />

      <WorkspaceSidebarSituation
        personaName={persona?.name}
        personaBrief={personaBrief}
        scenarioNarrative={scenario?.narrative}
      />

      <WorkspaceSidebarHighlights
        whatWorked={whatWorked}
        openQuestions={openQuestions}
        guidanceRules={guidanceRules}
      />
    </aside>
  );
}
